"use client";

import { useEffect, useRef } from "react";
import { track } from "@/lib/posthog-tracking";

interface PageViewTrackerProps {
  event: string;
  properties?: Record<string, unknown>;
}

export function PageViewTracker({ event, properties }: PageViewTrackerProps) {
  const sentRef = useRef(false);
  useEffect(() => {
    if (sentRef.current) return;
    sentRef.current = true;
    track(event, properties);
  }, [event, properties]);
  return null;
}
